import getFloatFromPriceString from '~/src/utils/helpers/getFloatFromPriceString';

export default function (currentValue) {
    const value = getFloatFromPriceString(currentValue);
    return Math.floor(value);
}
